// In development, use empty string to leverage Vite proxy
// In production, set VITE_API_URL to your API domain
const API_URL = import.meta.env.VITE_API_URL ?? '';

interface ApiResponse<T = any> {
  success: boolean;
  data?: T;
  error?: string;
  message?: string;
}

// Get auth token helper
let getTokenFn: (() => Promise<string | null>) | null = null;

export function setAuthTokenGetter(fn: () => Promise<string | null>) {
  getTokenFn = fn;
}

async function request<T>(
  endpoint: string,
  options: RequestInit = {}
): Promise<ApiResponse<T>> {
  try {
    console.log('Requesting:', `${API_URL}/api${endpoint}`);
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
      ...options.headers as Record<string, string>,
    };

    // Add auth token if available
    if (getTokenFn) {
      const token = await getTokenFn();
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }
    }

    const response = await fetch(`${API_URL}/api${endpoint}`, {
      ...options,
      headers,
      credentials: 'include',
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || 'Request failed');
    }

    return data;
  } catch (error) {
    console.error('API Error:', error);
    throw error;
  }
}

export const api = {
  get: <T>(endpoint: string) => request<T>(endpoint, { method: 'GET' }),
  
  post: <T>(endpoint: string, body?: any) =>
    request<T>(endpoint, {
      method: 'POST',
      body: JSON.stringify(body),
    }),
  
  patch: <T>(endpoint: string, body?: any) =>
    request<T>(endpoint, {
      method: 'PATCH',
      body: JSON.stringify(body),
    }),
  
  delete: <T>(endpoint: string, body?: any) =>
    request<T>(endpoint, {
      method: 'DELETE',
      body: body ? JSON.stringify(body) : undefined,
    }),
};

// Re-export all API hooks
export * from './api/useProfile';
export * from './api/useEvents';
export * from './api/useNeighborhoods';
export * from './api/useCities';
export * from './api/useReservations';
export * from './api/useAdminEvents';
export * from './api/useAdminUsers';
export * from './api/useAdminNeighborhoods';
export * from './api/usePayment';
export * from './api/useFeedback';
export * from './api/usePostDinner';
export * from './api/useConnections';
export * from './api/useChat';
export * from './api/usePolls';
export * from './api/useStats';


